/**
 * Color constants for box drawing components
 */

// Box fill colors (with transparency)
export const BOX_COLORS = {
  // Existing boxes (loaded on page load)
  existing: {
    fill: "rgba(59, 130, 246, 0.3)", // Blue
    fillSelected: "rgba(59, 130, 246, 0.2)", // Light blue when selected
    border: "#3b82f6", // Blue border
  },
  // User-drawn boxes
  userDrawn: {
    fill: "rgba(147, 51, 234, 0.3)", // Purple
    border: "#9333ea", // Purple border
  },
  // Box being drawn (temporary)
  drawing: {
    fill: "rgba(236, 72, 153, 0.3)", // Pink
    border: "#ec4899", // Pink border
  },
  // Product detection (read-only) — only the hovered box is drawn; solid white outline + soft glow
  detection: {
    border: "rgba(255, 255, 255, 0.95)", // Solid white outline (hovered box)
    glow: "rgba(255, 255, 255, 0.9)", // Soft white glow
  },
  // Selection handles
  handles: {
    fill: "#3b82f6", // Blue
    stroke: "#fff", // White
  },
};
